import { useGetFormValidationError } from "@tm/localization"
import { useMemo } from "react"
import { z } from "zod"

export function useSchema() {
    const getError = useGetFormValidationError()
    return useMemo(
        () =>
            z.object({
                name: z
                    .string({ required_error: getError("REQUIRED") })
                    .trim()
                    .min(1, getError("REQUIRED")),
                description: z.string().optional(),
            }),
        [getError]
    )
}
